import LessonFormModal from "./LessonFormModal"
import { MATCH_LESSON_TYPE } from "../utils/match.utils"

// "Gioco io": il modulo della lezione, che parte già da lì (vedi
// src/utils/match.utils.js). Ci si arriva dal menu del "+".
export function NewMatchModal({ closeModal, selectedDate }) {
	return (
		<LessonFormModal
			mode="new"
			startsAs={MATCH_LESSON_TYPE}
			closeModal={closeModal}
			selectedDate={selectedDate}
		/>
	)
}

export default NewMatchModal
